export default String.raw`
{% assign snippetProduct = product-presentation.Product -%}
{% capture snippetBase -%}{% include 'partials/common/absolute-base.html' -%}{% endcapture -%}
{% assign orgProtocol = snippetBase | Split: '//' | First -%}
{% assign orgHost = snippetBase | Split: '//' | Last | Split: '/' | First -%}
{% capture orgRoot -%}{{ orgProtocol }}//{{ orgHost }}/{% endcapture -%}
{% if config.Shop.ImageUrl contains '//' -%}
    {% assign orgLogo = config.Shop.ImageUrl -%}
{% elsif config.Shop.ImageUrl != null and config.Shop.ImageUrl != '' -%}
    {% capture orgLogo -%}{{ orgRoot }}{{ config.Shop.ImageUrl | Replace: '^[./]+', '' }}{% endcapture -%}
{% else -%}
    {% assign orgLogo = '' -%}
{% endif -%}
{% assign snippetName = snippetProduct.NameNoHtml | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign snippetDescription = snippetProduct.DescriptionNoHtml | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign snippetCategory = page.CurrentSiteNode.Name | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign snippetBrandName = snippetProduct.Brand.Name | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign snippetManufacturerName = snippetProduct.Manufacturer.Name | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign snippetSku = snippetProduct.Code | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign snippetGtin = snippetProduct.UPC | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign snippetMpn = snippetProduct.ManufacturerCode | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% capture snippetGroupId -%}{{snippetProduct.GIDNumber}}{% endcapture -%}
{% assign snippetGroupId = snippetGroupId | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign snippetSellerSource = config.Shop.ShortName -%}
{% if snippetSellerSource == null or snippetSellerSource == '' -%}
    {% assign snippetSellerSource = config.Shop.Name -%}
{% endif -%}
{% assign snippetSellerName = snippetSellerSource | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign snippetReviewsCount = 0 -%}
{% for review in feedback.Reviews -%}
    {% if review.Author != null and review.Author != '' -%}
        {% assign snippetReviewsCount = snippetReviewsCount | Plus: 1 -%}
    {% endif -%}
{% endfor -%}
{% assign snippetReviewTotal = 0 -%}
{% if feedback.TotalItems != null -%}
    {% assign snippetReviewTotal = feedback.TotalItems -%}
{% endif -%}
{% assign snippetAvailability = 'https://schema.org/InStock' -%}
{% if snippetProduct.Availability.Status == 0 -%}
    {% assign snippetAvailability = 'https://schema.org/PreOrder' -%}
{% elseif snippetProduct.Availability.Status == 2 -%}
    {% assign snippetAvailability = 'https://schema.org/LimitedAvailability' -%}
{% elseif snippetProduct.Availability.Status == 3 -%}
    {% assign snippetAvailability = 'https://schema.org/OutOfStock' -%}
{% endif -%}
{% assign snippetShowOffer = false -%}
{% if customer.HidePrices == false and snippetProduct.AskForPrice == false and snippetProduct.Price != null and snippetProduct.Price != '' -%}
    {% assign snippetShowOffer = true -%}
{% endif -%}
{% assign snippetImage = '' -%}
{% if snippetProduct.Image.Id > 0 and snippetProduct.Image.Link != null -%}
    {% capture snippetImage -%}{{snippetBase}}img/{{snippetProduct.Image.Id}}/{{snippetProduct.Image.Link}}{% endcapture -%}
{% elseif snippetProduct.Image.ExternalUrl != null and snippetProduct.Image.ExternalUrl != '' -%}
    {% assign snippetImage = snippetProduct.Image.ExternalUrl -%}
{% endif -%}
{% assign snippetImage = snippetImage | Replace: '[\r\n\t]+', '' | StripNewlines | Replace: '"', '\"' -%}
<script type="application/ld+json">
{
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "{{snippetName}}"
    {% if snippetImage != '' -%}
        ,"image": "{{snippetImage}}"
    {% endif -%}
    {% if snippetDescription != '' -%}
        ,"description": "{{snippetDescription}}"
    {% endif -%}
    {% if snippetCategory != '' -%}
        ,"category": "{{snippetCategory}}"
    {% endif -%}
    {% if snippetProduct.Brand and snippetBrandName != '' -%}
        ,"brand": {
            "@type": "Brand",
            {% if snippetProduct.Brand.Image.Id > 0 and snippetProduct.Brand.Image.Link != null -%}
                "logo" : "{{snippetBase}}img/{{snippetProduct.Brand.Image.Id}}/{{snippetProduct.Brand.Image.Link}}",
            {% elseif snippetProduct.Brand.Image.ExternalUrl != null and snippetProduct.Brand.Image.ExternalUrl != '' -%}
                "logo" : "{{snippetProduct.Brand.Image.ExternalUrl}}",
            {% endif -%}
            "name": "{{snippetBrandName}}"
        }
    {% endif -%}
    {% if snippetProduct.Manufacturer and snippetManufacturerName != '' -%}
        ,"manufacturer": {
            "@type": "Organization",
            {% if snippetProduct.Manufacturer.Image.Id > 0 and snippetProduct.Manufacturer.Image.Link != null -%}
                "logo" : "{{snippetBase}}img/{{snippetProduct.Manufacturer.Image.Id}}/{{snippetProduct.Manufacturer.Image.Link}}",
            {% elseif snippetProduct.Manufacturer.Image.ExternalUrl != null and snippetProduct.Manufacturer.Image.ExternalUrl != '' -%}
                "logo" : "{{snippetProduct.Manufacturer.Image.ExternalUrl}}",
            {% endif -%}
            "name": "{{snippetManufacturerName}}"
        }
    {% endif -%}
    {% if config.Reviews.Enabled == true and snippetProduct.RatingCount > 0 -%}
        ,"aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "{{snippetProduct.Rating | ToString | Replace: config.DecimalSeparator, '.'}}",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": "{{snippetProduct.RatingCount}}"
            {% if snippetReviewTotal > 0 -%}
            ,"reviewCount": "{{snippetReviewTotal}}"
            {% endif -%}
        }
    {% endif -%}
    {% if config.Reviews.Enabled == true and snippetReviewsCount > 0 -%}
        ,"review": [
            {% assign snippetReviewNo = 0 -%}
            {% for review in feedback.Reviews -%}
                {% if review.Author != null and review.Author != '' -%}
                    {% if snippetReviewNo > 0 %},{% endif -%}
                    {% assign snippetReviewNo = snippetReviewNo | Plus: 1 -%}
                    {% assign snippetReviewAuthor = review.Author | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
                    {% assign snippetReviewComment = review.Comment | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
                    {% assign snippetReviewDate = review.CreatedDate | Date: 'yyyy-MM-dd' -%}
                    {
                        "@type": "Review",
                        "author": {
                            "@type": "Person",
                            "name": "{{snippetReviewAuthor}}"
                        },
                        {% if snippetReviewDate != null and snippetReviewDate != '' -%}
                            "datePublished": "{{snippetReviewDate}}",
                        {% endif -%}
                        {% if snippetReviewComment != '' -%}
                            "description": "{{snippetReviewComment}}",
                        {% endif -%}
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": "{{review.Rating | ToString | Replace: config.DecimalSeparator, '.'}}",
                            "bestRating": "5",
                            "worstRating": "1"
                        }
                    }
                {% endif -%}
            {% endfor -%}
        ]
    {% endif -%}
    {% if snippetSku != '' -%}
        ,"sku": "{{snippetSku}}"
    {% endif -%}
    {% if snippetGtin != '' -%}
        ,"gtin": "{{snippetGtin}}"
    {% endif -%}
    {% if snippetMpn != '' -%}
        ,"mpn": "{{snippetMpn}}"
    {% endif -%}
    {% if snippetGroupId != '' and snippetGroupId != '0' -%}
        ,"inProductGroupWithID": "{{snippetGroupId}}"
    {% endif -%}
    {% if snippetProduct.Weight > 0 -%}
        ,"weight": {
            "@type": "QuantitativeValue",
            "value": "{{snippetProduct.Weight | ToString | Replace: config.DecimalSeparator, '.'}}",
            "unitCode": "KGM"
        }
    {% endif -%}
    {% if snippetShowOffer -%}
        ,"offers": {
            "@type": "Offer",
            "priceCurrency": "{{ customer.Currency }}",
            "price": "{{snippetProduct.Price | ToString | Replace: config.DecimalSeparator, '.'}}",
            "url": "{{snippetBase}}{{snippetProduct.Url}}",
            {% if snippetSellerName != '' -%}
                "seller": {
                    "@type": "Organization",
                    {% if orgHost != null and orgHost != '' -%}
                        "@id" : "{{orgRoot}}#organization",
                        {% if orgLogo != '' -%}
                            "logo" : "{{orgLogo}}",
                        {% endif -%}
                    {% endif -%}
                    "name": "{{snippetSellerName}}"
                },
            {% endif -%}
            "availability": "{{snippetAvailability}}"
        }
    {% endif -%}
}
</script>
`